import React from 'react';

const DocumentList = ({ 
  documents, 
  selectedDocument, 
  isLoading, 
  onViewDocument,
  onEditDocument,
  onDeleteDocument 
}) => {
  return (
    <div className="document-list-container">
      <div className="document-list-header">
        <h3>Documents de la société</h3>
      </div>
      <div className="document-list-content">
        {isLoading ? (
          <div className="document-list-loading">
            <div className="loading-spinner rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : documents.length === 0 ? (
          <div className="document-list-empty">
            Aucun document générique disponible
          </div>
        ) : (
          <div className="document-list-items">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className={`document-item ${selectedDocument?.id === doc.id ? 'selected' : ''}`}
              >
                <div className="document-item-header">
                  <div 
                    className="document-item-content cursor-pointer"
                    onClick={() => onViewDocument(doc)}
                  >
                    <div className="document-item-name">
                      {doc.documentName}
                      {doc.isCustom && (
                        <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                          Personnalisé
                        </span>
                      )}
                    </div>
                    <div className="document-item-description">
                      {doc.description}
                    </div>
                  </div>
                  <span className="document-item-version">
                    v{doc.version}
                  </span>
                </div>
                <div className="document-item-footer">
                  <div className="document-item-date">
                    {doc.metadata?.updatedAt?.toDate?.()?.toLocaleDateString('fr-FR') || 
                     doc.metadata?.createdAt?.toDate?.()?.toLocaleDateString('fr-FR') || 'Date inconnue'}
                  </div>
                  <div className="document-item-actions">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditDocument(doc);
                      }}
                      className="text-blue-600 hover:text-blue-800 transition-colors"
                      title="Modifier le document"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteDocument(doc);
                      }}
                      className="text-red-600 hover:text-red-800 transition-colors ml-2"
                      title="Supprimer le document"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentList;
